import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../apiConfig";
import BannerPageTitle from "../Components/UIcomponents/BannerPageTitle";
import logo from '../images/logo.png';

function About() {
    const [content, setContent] = useState('');

    useEffect(() => {
        const language = document.getElementById('language')?.value || '1';
        axios.get(`${API_BASE_URL}/about/${language}`).then((res) => {
            setContent(res.data.about.about_btcl);
        });
    }, []);

    return (
        <div style={{ background: '#f4f6fa', minHeight: '100vh', paddingBottom: '4rem' }}>
            <BannerPageTitle 
                title='About BTCL' 
                subtitle='Discover our history, mission, and dedication to the sport'
            />
            <div style={{ 
                maxWidth: '900px', 
                margin: '-40px auto 0 auto', 
                padding: '3rem 2.5rem', 
                minHeight: '50vh', 
                background: '#ffffff', 
                borderRadius: '12px', 
                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                position: 'relative',
                zIndex: 10,
                borderTop: '4px solid var(--blue)'
            }}>
                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    gap: '20px', 
                    marginBottom: '2rem', 
                    borderBottom: '2px solid #f0f0f0', 
                    paddingBottom: '1.5rem',
                    textAlign: 'center',
                    flexWrap: 'wrap'
                }}>
                    <img src={logo} alt="BTCL Logo" style={{ height: '70px', objectFit: 'contain' }} />
                    <h2 style={{ 
                        fontFamily: 'var(--fontDisplay), "Oswald", sans-serif', 
                        fontSize: 'clamp(1.5rem, 4vw, 2.2rem)', 
                        color: 'var(--blue)', 
                        margin: 0, 
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                    }}>
                        British Tamil Cricket League
                    </h2>
                </div>
                <div dangerouslySetInnerHTML={{ __html: content }} style={{ 
                    font: '400 1.1rem/1.8 var(--fontBody), sans-serif', 
                    color: '#333',
                    textAlign: 'justify'
                }}></div>
            </div>
        </div>
    );
}

export default About;
